// Lines of a road closure / detour from the Datenportal (closureMapData / detourMapData):
// { coordinates: [[lat, lng], …], lines?: [[[lat, lng], …], …] }. `lines` holds all
// (unconnected) sections; data saved before multiple lines existed only has `coordinates`.

export type LatLng = [number, number];

function toLine(value: unknown): LatLng[] | undefined {
  if (!Array.isArray(value) || value.length < 2) return undefined;
  const line: LatLng[] = [];
  for (const point of value) {
    if (
      !Array.isArray(point) ||
      typeof point[0] !== "number" ||
      typeof point[1] !== "number"
    )
      return undefined;
    line.push([point[0], point[1]]);
  }
  return line;
}

export function parseRoadClosureLines(mapData: unknown): LatLng[][] {
  if (!mapData || typeof mapData !== "object") return [];
  const data = mapData as { lines?: unknown; coordinates?: unknown };
  if (Array.isArray(data.lines)) {
    const lines = data.lines
      .map(toLine)
      .filter((line): line is LatLng[] => !!line);
    if (lines.length > 0) return lines;
  }
  const single = toLine(data.coordinates);
  return single ? [single] : [];
}
